import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './NotificationDropdown.css'
import React, { useEffect, useRef } from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteNotif } from '../../services/callAPI/notifications';

export type Tnotification = {
  id: number | undefined;
  notif_nature: string;
  message: string;
  isRead: boolean;
}

interface Props {
  listNotif: Tnotification[] | undefined;
  onClose: () => void; // fonction à appeler quand on clique à l’extérieur
  setlistNotif: React.Dispatch<React.SetStateAction<Tnotification[]>>
}

const NotificationDropdown: React.FC<Props> = ({ listNotif, onClose, setlistNotif }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onClose(); // ferme la liste
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose])

  async function handleDeleteNotif(notifId: number | undefined) {
    if (notifId === undefined) return;

    try {
      await deleteNotif(notifId);
      setlistNotif((prev) => prev?.filter((notif) => notif.id !== notifId));
    } catch (error) {
      console.error('Erreur lors de la suppression de la notification :', error);
    }
  }

  return (
    <div
      id='div-dropdown-notif'
      ref={dropdownRef}
      className="absolute top-0 right-0 mt-2 w-44 p-1 bg-white border border-gray-300 rounded-lg shadow-lg z-50"
    >
      {listNotif != null && listNotif.length > 0 ? (
        <ul className="divide-y divide-gray-200 max-h-60 overflow-y-auto custom-scrollbar">
          {listNotif.map((notif, _idx) => (
            <li
              key={notif.id}
              className={`flex justify-between items-center gap-2 py-2 text-sm ${notif.isRead ? "bg-white" : "bg-blue-100"} hover:bg-gray-100 cursor-pointer`}
            >
              {notif.message}
              <span onClick={() => handleDeleteNotif(notif.id)}><FontAwesomeIcon icon={faTrash} color='#9E2A2B' /></span>
            </li>
          ))}
        </ul>
      ) : (
        <div
          className="px-4 py-2 text-sm text-gray-500"
          onClick={onClose}
        >
          Aucune notification
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;